// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--1gKkt","quote":"index-module--quote--2vlLR","author":"index-module--author--WiioF"};